export const RANDOM_DEEP_LINK = 'mvp_400_ab';
export const GGL_REF_CODE = 'ggl';
export const DISPLAY_42 = 'display_42';
export const UTM_CAMPAIGN = {
  display_test: 'display_test',
  display_ab: 'display_ab',
};
export const REF_CODE = {
  mvp400: 'mvp_400',
  mvpFree: 'mvp_free',
};
